<template>
<a href="javascript:void(0)" :class="current" :data-scp="scp" @click="goback">
	<i class="icon icon-back"></i>
	<span>返回</span>
</a>
</template>

<script>
export default {
	props: ['current', 'scp']
//	, ready: function(){
//		if( document.referrer && !/mendianxuanze\.html/.test(location.href) ){
//			this.$set('referrer', document.referrer);
//		}
//		else{
//			this.$set('referrer', '/index.html');
//		}
//	}
	, data: function(){
		return {
			enable: true
		};
	}
	, methods: {
		goback: function(){
			// 触发事件
			// var rs = maple.component.event.triggerHandler('headerGoBack', [this]);
			// 事件返回值为是否阻断事件执行，当事件未定义时，返回值为 undefined
			// 期望返回值为 boolean 类型
			// if( rs !== undefined && !rs ){
			// 	return;
			// }

			if( this.enable ){
				history.back();
			}
			else{	// 返回按钮不可用时向父级发送 goBack 事件
				this.$dispatch('goBack');
			}
		}
	}
	, events: {
		toggleGoBack: function(enable){	// 父级决定返回按钮是否可用
			this.enable = enable;
		}
	}
}
</script>